import { render, staticRenderFns } from "./BuyerVehicles.vue?vue&type=template&id=6793cf3f"
import script from "./BuyerVehicles.vue?vue&type=script&lang=js"
export * from "./BuyerVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports